// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_SELLERS = "GET_SELLERS";
export const CREATE_SELLERS = "CREATE_SELLERS";
export const UPDATE_SELLERS = "UPDATE_SELLERS";
export const DELETE_SELLERS = "DELETE_SELLERS";
